import { useCallback } from 'react';

import { Badge } from '../../../components/ui';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { MAU_NGUOI_NOI } from '../constants';
import { chiSoNguoiNoi, tenDaDat, viTriMauNguoiNoi } from '../nghiep-vu/bien-ban';
import type { NguoiNoi } from '../types';

export const mauCua = (label: string) => MAU_NGUOI_NOI[viTriMauNguoiNoi(label, MAU_NGUOI_NOI.length)]!;

/** Tên hiện ra của một nhãn: tên người dùng đặt, chưa đặt thì "Người nói 1", đoạn không nhãn thì "Chưa rõ người nói". */
export function useTenNguoiNoi(speakers: readonly NguoiNoi[]) {
  const { t, locale } = useT();
  return useCallback(
    (label: string | null): string => {
      if (!label) return t('bienBan.loi.chuaRo');
      return tenDaDat(label, speakers) ?? t('bienBan.loi.nguoiNoiSo', { so: soVN(chiSoNguoiNoi(label) + 1, locale) });
    },
    [t, locale, speakers],
  );
}

export function BadgeNguoiNoi({ label, ten }: { label: string | null; ten: string }) {
  return <Badge variant={label ? mauCua(label).badge : 'neutral'} className="max-w-full"><span className="truncate">{ten}</span></Badge>;
}
